import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { MainService } from './main.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class WorkService {

  httpUrl;

  constructor(private http: HttpClient, private main: MainService, private spinner: NgxSpinnerService) {
    this.httpUrl = this.main.httpUrl + '/accounts/work';
  }


  async viewWorkDocOnId(element: any) {
    this.spinner.show();
    let obj_doc = Object()
    obj_doc['b_acct_id'] = element.b_acct_id;
    obj_doc['work_id'] = element.work_id;
    obj_doc['key'] = element.key;

    const res: any = await this.view_doc_on_id(obj_doc);
    await this.openDocNewWindow(res)
  }




  async viewDoc(element: any) {
    this.spinner.show();
    let obj_doc = Object()
    obj_doc['b_acct_id'] = element.b_acct_id;
    obj_doc['work_id'] = element.work_id;
    obj_doc['file_name'] = element.file_name
    const res: any = await this.view_doc(obj_doc);
    await this.openDocNewWindow(res)
  }

  async openDocNewWindow(res: any) {
    try {
      if (res.type == 'application/pdf') {
        const file = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire('INFO', 'Document not Uploaded', 'info');
      }
    } catch (error) {
      this.spinner.hide();
      console.error('Failed to load document:', error);
    }
  }





  async getWorkList(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/getworkInfo' + JSON.stringify(obj)).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getAllModuleWork(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/allModuleWork' + JSON.stringify(obj)).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getWorkDetailsByID(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/getWorkDetailsByID' + JSON.stringify(obj)).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updateWork(obj: any) {
    const resp = await this.http.put<any>(this.httpUrl + '/updateWork', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async changeWorkStatus(obj: any) {
    const resp = await this.http.put<any>(this.httpUrl + '/changeWorkStatus', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async deleteWork(obj: any) {
    const res = await this.http.put<any>(this.httpUrl + '/deleteWork', obj).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async createWork(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/createWork', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }


  async costCenterMapped(obj: any) {
    const res = await this.http.get<any>(this.httpUrl + '/costCenterMapped' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }

  async workMapped(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/workedMappedOnCC' + obj).toPromise().then(res => {
      return res;
    })
    return resp;
  }

  async view_doc(obj: any) {
    const resp = await this.http.get(this.httpUrl + '/viewWorkDoc' + JSON.stringify(obj), { responseType: 'blob' }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async view_doc_on_id(obj: any) {
    const resp = await this.http.get(this.httpUrl + '/viewById' + JSON.stringify(obj), { responseType: 'blob' }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async workAssignment(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/w_assignment', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }


}
